module.exports = __webpack_public_path__ + "img/img7.52a06c09.png";